import _min from 'lodash/min';
import _filter from 'lodash/filter';
import _reject from 'lodash/reject';
import _sortBy from 'lodash/sortBy';

import MEMBERSHIP_STATUSES from 'constants/membershipStatuses';

function Ctrl($scope, $rootScope, utilsService, bookingHelpers, modalService, metaTagService, jsSdkUser, jsSdkMembership) {
  metaTagService.set({
    title: 'Dashboard | Tablelist',
    description: 'Manage your VIP table bookings, make changes to your account and more.'
  });

  $scope.MEMBERSHIP_STATUSES = MEMBERSHIP_STATUSES;

  $scope.bookingsPromise
    .then(function success(response) {
      $scope.nextUpcomingBooking = nextUpcomingBooking(response);
    })
    .catch(response => {
      $scope.errorMsg = utilsService.errorMessage(response);
    });

  function nextUpcomingBooking(bookings) {
    bookings = _filter(bookings, bookingHelpers.isUpcomingBooking);

    const upcoming = _min(bookings, function(booking) {
      return booking.date;
    });

    $scope.loading = false;

    if (!upcoming || !upcoming.venue) return null;

    upcoming.mapURL = utilsService.getMapUrl(upcoming.venue.location.address, true);

    return upcoming;
  }

  $scope.editCities = function() {
    modalService.editCities();
  };

  $scope.enterPromo = function() {
    modalService.enterPromo();
  };

  $scope.editCreditCard = function() {
    modalService.editCreditCard();
  };

  loadMembership();

  function loadMembership() {
    $scope.loadingMembership = true;

    jsSdkMembership.listByUserId(jsSdkUser.getCurrentUser().id, {})
      .then(resp => {
        $scope.loadingMembership = false;

        const memberships = _sortBy(_reject(resp, {
          status: MEMBERSHIP_STATUSES.CANCELLED
        }), 'created');

        if (memberships && memberships[0]) {
          $scope.membership = memberships[0];
        }
      })
      .catch(() => {
        $scope.loadingMembership = false;
      });
  }
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  'utilsService',
  'bookingHelpersService',
  'modalService',
  'metaTagService',
  'jsSdk.user',
  'jsSdk.membership'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/accountDashboard/accountDashboardCtrl.js